export function isFirstDraft(planName: null | string): boolean {
  return !!planName?.toLowerCase().includes("first draft");
}

export function isFullyManaged(
  origin: null | string,
  planName: null | string,
): boolean {
  return origin !== "kickstarter" && !planName?.toLowerCase().includes("core");
}
